import { Guide } from '../components/Guide'
import { guides } from '../content/guides'

export const RoleScenariosPage = () => <Guide content={guides.scenarios} />
